export const env = {    
    //baseURL: process.env.REACT_APP_API_URL || 'https://hml-api-peticoes.dpu.def.br/api/' //HOMOLOGAÇÃO BACKEND
    baseURL: process.env.REACT_APP_API_URL || 'https://api-peticoes.dpu.def.br/api/' //PRODUÇÃO BACKEND   
    //baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/' //LOCAL BACKEND  

}     